import { Component, Input, ChangeDetectionStrategy, Injector } from '@angular/core'
import { Store } from '@ngrx/store'
import { NavController } from 'ionic-angular'
import { UIEventHub } from '../../../services/event.service'
import { ActionCreator } from '../../../services/action.service'
import { ViewModel } from '../../../view-model'
import { BaseWidget } from '../../base-widget'
import { FormControl } from '@angular/forms'
/**
 * タブプルダウン
 *【選択候補:items:{label:string,value:string}[]】
 *【最大数:max:number】
 *【デフォルト:defaultIndex:number】
 *【プレースホルダ:placeholder:string】
 *【選択タグ:selectedTab:number】
 *【フォームコントロール:formControl:FormControl】
 * @author nabla2.metamodel.generator
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-tab-pulldown',
  templateUrl: './tab-pulldown.html',
  styles: [`
    
  `]
})
export class TabPulldown extends BaseWidget {
  /**
   * 選択タグの表示モデルパス
   */
  @Input() viewModelPath:string

  /**
   * 選択タグに対する精査エラー
   */
  @Input() errorMessages:{modelPath:string, message:string}[]

  /**
   * 選択候補
   */
  @Input() items:{label:string,value:string}[]

  /**
   * 最大数
   */
  @Input() max:number

  /**
   * デフォルト
   */
  @Input() defaultIndex:number

  /**
   * プレースホルダ
   */
  @Input() placeholder:string

  /**
   * 選択タグ
   */
  @Input() selectedTab:number

  /**
   * フォームコントロール
   */
  @Input() formControl:FormControl

  /**
   * コンストラクタ
   * @param navCtrl 画面遷移管理サービス
   * @param store Reduxストア
   */
  constructor(
    public navCtrl: NavController,
    public store: Store<{viewModel:ViewModel}>,
    public eventHub: UIEventHub,
    public actionCreator: ActionCreator,
    public injector: Injector,
  ) {
    super(injector)
  }
  public clickTab(data) {
    this.store.dispatch(this.actionCreator.updateViewModel(
      this.viewModelPath,
      (m) => data.value,
      {id:this.id, type:data.event, source:new Event(data.event)},
      `update by ${this.id}`,
    ))
    this.on(data.event)
  }
  
  get config() {
    const config = {
      max: this.max,
      defaultValue: this.defaultIndex,
      placeholder: this.placeholder
    }
    return config;
  }
  
  ngOnInit() {
    if (!this.formControl) {
      this.formControl = new FormControl('');
    }
  }

  /**
   * このコンポーネントの状態をバインドされた表示項目の状態に反映する。
   * @param event イベント
   */
  update(event:Event) {
    const node = <HTMLFormElement>event.target
    const value = node.value
    this.store.dispatch(this.actionCreator.updateViewModel(
      this.viewModelPath,
      (m) => value,
      {id:this.id, type:event.type, source:event},
      `update by ${this.id}`,
    ))
    this.on(event)
  }
}


// WEBPACK FOOTER //
// ./src/widgets/tab/tab-pulldown/tab-pulldown.component.ts